import { useMemo } from "react";
import styles from "./NBLogoWhite.module.css";

const NBLogoWhite = ({showLogo=true}) => {
  return (
    <img
      className={`${styles.logo } ${showLogo ? styles.logoVisible : ''}`}
      alt=""
      src="./NB_white.png"
      onClick={() => window.open('https://www.newbalance.com/')}
    />
  );
};

export default NBLogoWhite;
